export type Location = {
  lat: number | undefined;
  lng: number | undefined;
  acc: number | undefined;
  speed: number | null;
  heading: number | null;
};

export interface LocationItem {
  phone: string | undefined;
  roomId: string | undefined;
  type: string | undefined;
  locateLogs: Location[];
}

export interface DetailItem {
  accDate: string;
  accDtl: string;
  accLoc: string;
  accTime: string;
  expireTime: string;
  dLoc: string;
  wCond: string;
  accType: string;
  dType: string;
  dRoute: string;
  mdn: string;
  lat: number;
  lng: number;
  prcRslt: string | undefined;
  roomId: string | undefined;
  saveTime: string;
  userInfos: any;
  isOpen: boolean;
  belong: string;
  userName: string;
  alimType: string;
}

export const ManagerItems = [
  {
    name: '해양사고 통계',
    index: 0,
  },
  {
    name: '출동실적 통계',
    index: 1,
  },
  {
    name: '해양재난구조대원 관리',
    index: 2,
  },
  {
    name: '사용자 관리',
    index: 3,
  },
];

export const RoomInfoItems = [
  {
    id: 'dLoc',
    title: '동원장소',
    options: [
      '확인중',
      '해상(항계 내)',
      '해상(영해 내)',
      '해상(영해 外)',
      '육상(해안가,갯바위,갯벌)',
      '육상(방파제,테트라포트)',
      '기타',
    ],
  },
  {
    id: 'wCond',
    title: '기상상태',
    options: ['확인중', '기상양호', '저시정', '풍랑주의보', '풍랑경보', '태풍주의보', '태풍경보'],
  },
  {
    id: 'accType',
    title: '사고유형',
    options: ['확인중', '선박고장', '충돌/접촉', '좌초/좌주', '전복', '화재', '침몰', '침수', '기타'],
  },
  {
    id: 'dType',
    title: '동원유형',
    options: ['확인중', '인명구조', '실종자 수색', '선박예인', '선박구난', '기타'],
  },
  {
    id: 'dRoute',
    title: '동원경로',
    options: ['해양경찰', '자발적 참여', '동료대원'],
  },
];

export const ArrivalTimeItems = [
  {
    name: '10분 이내',
    value: 10,
  },
  {
    name: '20분 이내',
    value: 20,
  },
  {
    name: '30분 이내',
    value: 30,
  },
  {
    name: '40분 이내',
    value: 40,
  },
  {
    name: '50분 이내',
    value: 50,
  },
  {
    name: '60분 이내',
    value: 60,
  },
];
